import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { COPIES_PREFIX } from '../../constants';

interface SubCategoryDisplayProps {
  subCategoryName: string;
}
export const SubCategoryDisplay = ({ subCategoryName }: SubCategoryDisplayProps) => (
  <I18n
    k={`${COPIES_PREFIX}.featured_in_sub_category`}
    params={{ subCategoryName }}
    templates={{
      span: (text) => <span className="text-semi-bold">{text}</span>,
    }}
  />
);
